document.addEventListener('click', function (event) {
  const button = event.target.closest('.product-form__buy-now');
  if (!button) return;

  event.preventDefault();
  if (button.hasAttribute('disabled')) return;

  const spinner = button.querySelector('.loading__spinner');
  const label = button.querySelector('.product-form__buy-now-label');
  const form = button.closest('form');
  const variantInput = form ? form.querySelector('.product-variant-id') : null;
  const variantId = (variantInput && variantInput.value) || button.dataset.variantId;
  const quantityInput = form ? form.querySelector('input[name="quantity"]') : null;
  const quantity = (quantityInput && Number(quantityInput.value)) || 1;

  button.setAttribute('disabled', true);
  if (spinner) spinner.classList.remove('hidden');
  if (label) label.dataset.originalText = label.textContent;

  fetch(button.dataset.cartAddUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] }),
  })
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        if (label) label.textContent = response.description || 'No se pudo procesar la compra.';
        button.removeAttribute('disabled');
        if (spinner) spinner.classList.add('hidden');
        return;
      }
      window.location.href = button.dataset.checkoutUrl;
    })
    .catch(() => {
      if (label) label.textContent = 'Ocurrió un error, intentá de nuevo.';
      button.removeAttribute('disabled');
      if (spinner) spinner.classList.add('hidden');
    });
});
